module.exports = __webpack_public_path__ + "img/72.0f1f09f3.png";